import React, { useMemo, Fragment } from 'react';
import cn from 'classnames';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';

import { useChartContext } from '../../hooks';
import { SYMBOL_BY_PERIOD } from '../../constants';
import { getVisibleData, getVisibleDates } from '../../helpers';

import styles from './styles.styl';
import MeasurementTitles from './MeasurementTitles';

const ChartHeader = ({ config, nothing, loading, noTabs }) => {
  const {
    mark,
    period,
    sources,
    formats,
    setPeriod,
    activeSource,
    converter = noop,
  } = useChartContext();

  const filteredSources =
    activeSource && sources.includes(activeSource) ? [activeSource] : sources;

  const data = useMemo(() => getVisibleData(config, filteredSources), [
    config,
    filteredSources,
  ]);

  const dates = useMemo(() => getVisibleDates(config, period), [
    config,
    period,
  ]);
  const measurementOptions = {
    data,
    mark,
    dates,
    config,
    sources,
    loading,
    formats,
    nothing,
    converter,
    period,
    activeSource,
  };

  return (
    <Fragment>
      <MeasurementTitles {...measurementOptions} />
      {!noTabs && (
        <div className={styles.periods}>
          {Object.entries(SYMBOL_BY_PERIOD).map(([periodName, symbolName]) => (
            <div
              aria-hidden
              key={periodName}
              onClick={() => setPeriod(periodName)}
              className={cn(styles.period, {
                [styles.active]: periodName === period,
              })}
            >
              {symbolName}
            </div>
          ))}
        </div>
      )}
    </Fragment>
  );
};

ChartHeader.propTypes = {
  noTabs: PropTypes.bool,
  nothing: PropTypes.bool,
  loading: PropTypes.bool,
  config: PropTypes.object,
};

export default ChartHeader;



// WEBPACK FOOTER //
// ./src/components/common/Charts/ChartWrapper/ChartHeader/index.jsx